import { entryGroups, feedPosts, hotRegions, leadPost } from '@/mocks/gossipData';
import { StatusBadge } from './common';

export default function UpdateRail() {
  const railPosts = feedPosts.slice(0, 5);
  return (
    <section id="live" className="w-full scroll-mt-24 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-6 md:px-6 md:py-8">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="h-2 w-2 animate-pulse rounded-full bg-primary-500" />
              <span className="text-xs font-bold tracking-widest text-primary-600 uppercase">入口 · 实时进展</span>
            </div>
            <h1 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-4xl">吃瓜前线 · 最新进展</h1>
            <p className="mt-1.5 text-sm text-foreground-600 md:text-[15px]">
              辟谣、反转、当事人回应与后续进展，统一入口一站看清。
            </p>
          </div>
          <div className="flex flex-wrap gap-2 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1.5 rounded-full border border-background-200 bg-background-100 px-3 py-1.5">
              <i className="ri-refresh-line text-primary-500" /> {hotRegions.updated}
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full border border-background-200 bg-background-100 px-3 py-1.5">
              <i className="ri-focus-3-line text-accent-600" /> {hotRegions.online}
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full border border-background-200 bg-background-100 px-3 py-1.5">
              <i className="ri-chat-3-line text-secondary-600" /> {hotRegions.daily}
            </span>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-5 lg:grid-cols-3">
          <a
            href="#feed"
            className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 md:col-span-2 lg:flex-row"
          >
            <div className="relative h-52 w-full overflow-hidden lg:h-auto lg:min-h-[300px] lg:w-[46%]">
              <img
                src={leadPost.image}
                alt="抖阴黑料 今日反转事件配图"
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-4 md:p-5">
              <div className="flex items-center gap-2">
                <StatusBadge label={leadPost.kind} />
                <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-900">
                  <i className="ri-fire-line" /> 今日风向
                </span>
              </div>
              <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[22px]">
                {leadPost.title}
              </h3>
              <p className="mt-2.5 line-clamp-3 text-sm leading-relaxed text-foreground-600">{leadPost.summary}</p>
              <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-focus-3-line text-primary-500" /> {leadPost.source}
                </span>
                <span className="inline-flex items-center gap-3">
                  <span className="inline-flex items-center gap-1"><i className="ri-chat-3-line" /> {leadPost.comments}</span>
                  <span className="inline-flex items-center gap-1 text-foreground-700 transition-colors group-hover:text-primary-700">
                    展开时间线 <i className="ri-arrow-right-line" />
                  </span>
                </span>
              </div>
            </div>
          </a>

          <div className="flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50">
            <div className="flex items-center justify-between border-b border-background-200 px-4 py-3 md:px-5">
              <span className="inline-flex items-center gap-1.5 text-sm font-bold text-foreground-900">
                <i className="ri-radio-2-line text-primary-500" /> 滚动快讯
              </span>
              <button type="button" className="cursor-pointer text-xs text-primary-600 hover:text-primary-700">
                全部动态
              </button>
            </div>
            <div className="flex flex-col divide-y divide-background-200">
              {railPosts.map((p, idx) => (
                <a href="#feed" key={p.id} className="group flex cursor-pointer gap-3 px-4 py-3 transition-colors hover:bg-background-100 md:px-5">
                  <span className="mt-0.5 font-heading text-lg font-black text-background-300 transition-colors group-hover:text-primary-500">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-foreground-950">
                      {p.title}
                    </p>
                    <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
                      <StatusBadge label={p.kind} className="!px-1.5 !text-[10px]" />
                      <span>{p.time}</span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-5 flex flex-wrap items-center gap-2.5">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-bold text-foreground-700">
            <i className="ri-compass-3-line text-primary-500" /> 按主题逛：
          </span>
          {entryGroups.map((g) => (
            <a
              key={g.label}
              href="#collection"
              className="group inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-background-200 bg-background-100 py-1.5 pl-3 pr-2 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <i className={`${g.icon} text-sm text-primary-600 transition-colors group-hover:text-primary-700`} />
              <span className="text-sm font-semibold text-foreground-900">{g.label}</span>
              <span className="rounded-full bg-background-50 px-2 py-0.5 text-[11px] text-foreground-500">{g.count}</span>
              <i className="ri-arrow-right-s-line text-foreground-400" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}